import React from 'react';
import Canvas from './components/Canvas';
import "./styles/App.css";

function App() {
  return (
    <div className="min-h-screen w-full bg-gradient-to-r from-[#aa79ff] via-[#cdb128] to-[#aa79ff]">
      <Canvas />
    </div>
  );
}

export default App;
